import React from "react";
import { TextField } from "@mui/material";
import "./form.css";

function FieldText(props) {
  const {
    id,
    className = "",
    value = "",
    onChange,
    error = false,
    label = "",
    errorMsg = "",
    rows = 3,
    defaultValue = "",
    maxRows = Infinity,
    multiline = false,
    disabled = false,
    restrictLenghth = 0
  } = props;

  // console.log(onChange);
  // console.log(label);
  return (
    <div className={`width100 ${className}`}>
      <TextField
        className="muiTextField"
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        size={"small"}
        error={error}
        id={id}
        label={label}
        defaultValue={defaultValue}
        helperText={errorMsg}
        value={value}
        onChange={onChange}
        inputProps={restrictLenghth && { maxLength: restrictLenghth }}
      />
    </div>
  );
}

export default FieldText;
